<div class="table-header">
    @if (block().title) {
        <p class="table-title">{{ block().title }}</p>
    }
    <!-- Grouped so the pair stays together at the right edge whether or not there is a title. -->
    <div class="table-actions">
        <!-- FR-047: a real <button>, so it is keyboard-reachable like every other control (FR-031). -->
        <button type="button" class="table-copy" (click)="copy()" aria-label="Copy table">Copy</button>
        <!-- FR-027: export covers the rows the block carries, with no new request and no chat turn. -->
        <button type="button" class="table-export" (click)="downloadCsv()" aria-label="Export table as CSV">
            Export CSV
        </button>
    </div>
</div>
<!-- The scroller, not the table, owns the overflow: at side-panel width (FR-028) a wide table
     scrolls within the block rather than widening the conversation. -->
<div class="table-scroll">
    <table class="table">
        <thead>
            <tr>
                @for (column of block().columns; track column.key) {
                    <!-- aria-sort on the header is what a screen reader announces; the arrow is
                         the sighted equivalent, so neither audience depends on the other. -->
                    <th scope="col" [class.cell-numeric]="isNumeric(column)" [attr.aria-sort]="sortedBy(column)">
                        <button type="button" class="column-sort" (click)="toggleSort(column)">
                            <span>{{ column.label }}</span>
                            @if (column.unit) {
                                <span class="column-unit">({{ column.unit }})</span>
                            }
                            <span class="sort-arrow" aria-hidden="true">
                                @switch (sortedBy(column)) {
                                    @case ('ascending') {
                                        &#9650;
                                    }
                                    @case ('descending') {
                                        &#9660;
                                    }
                                }
                            </span>
                        </button>
                    </th>
                }
            </tr>
        </thead>
        <tbody>
            @for (row of displayRows(); track $index) {
                <!-- Row emphasis and cell emphasis are independent and both render (FR-045). -->
                <tr
                    [class.row-critical]="row._emphasis === 'critical'"
                    [class.row-warning]="row._emphasis === 'warning'"
                    [class.row-ok]="row._emphasis === 'ok'"
                    [class.row-info]="row._emphasis === 'info'"
                >
                    @for (column of block().columns; track column.key) {
                        <td
                            [class.cell-numeric]="isNumeric(column)"
                            [class.cell-critical]="cellEmphasis(row, column) === 'critical'"
                            [class.cell-warning]="cellEmphasis(row, column) === 'warning'"
                            [class.cell-ok]="cellEmphasis(row, column) === 'ok'"
                            [class.cell-info]="cellEmphasis(row, column) === 'info'"
                        >
                            @if (column.kind === 'status' && statusValue(row, column); as status) {
                                <copilot-rich-block-status [status]="status" />
                            } @else {
                                <!-- `link` marks the row's identity column. It is styled as the
                                     entity it names but is not yet a navigation target, matching
                                     the navigate action, which renders without acting. -->
                                <span [class.cell-link]="column.link">{{ displayValue(row, column) }}</span>
                            }
                        </td>
                    }
                </tr>
            }
        </tbody>
    </table>
</div>
<!-- Only when the block is a sample: a footer on a complete table would be noise. -->
@if (isTruncated()) {
    <p class="table-footer">Showing {{ block().rows.length }} of {{ totalRows() }}</p>
}
